import BigNumber from "bignumber.js";

interface IProps {
  estimatedAmount: string;
  maxSlippage: string;
  toCurrencyDecimals: number;
}

export const getMinGetAmount = (props: IProps) => {
  const { estimatedAmount, maxSlippage, toCurrencyDecimals } = props;

  if (!estimatedAmount || !maxSlippage) {
    return "-";
  }

  const estimatedAmountBN = new BigNumber(estimatedAmount);
  const maxSlippageBN = new BigNumber(maxSlippage);
  const oneBN = new BigNumber(1);

  return estimatedAmountBN
    .multipliedBy(oneBN.minus(maxSlippageBN))
    .decimalPlaces(toCurrencyDecimals, 1)
    .toFixed()
    .toString();
};
